import { Grid } from '@mui/material'
import { LabeledText, TitledSection } from '../../../../../components'
import { Maybe, MembershipCard } from '../../../../../utils/classes/graphql'
import { SaveMembershipCardForm } from './save-membership-card-form'

export type MaybeMembershipCard = Maybe<MembershipCard> | undefined

export interface MembershipCardInfoProps {
  membershipCard: MaybeMembershipCard
}

export const MembershipCardInfo = ({
  membershipCard
}: MembershipCardInfoProps) => {
  return (
    <TitledSection translationid="pages.ownInfoPage.membership.membershipCard.label">
      <Grid container rowSpacing={1} alignItems="center">
        <Grid item md={4} xs={12}>
          <LabeledText
            labelTranslationId="pages.ownInfoPage.membership.membershipCard.type"
            texts={[
              membershipCard?.jasenkortin_tyyppi_nimi ||
                membershipCard?.jasenkortin_tyyppi
            ]}
          />
        </Grid>
        <Grid item md={true} xs={12}>
          <LabeledText
            labelTranslationId="pages.ownInfoPage.membership.membershipCard.deliveryDate"
            texts={[membershipCard?.jasenkortin_toimituspvm]}
          />
        </Grid>
        <Grid item md="auto" xs={12}>
          <SaveMembershipCardForm membershipCard={membershipCard} />
        </Grid>
      </Grid>
    </TitledSection>
  )
}
